import { createContext, useContext, useState } from 'react';
import useRetainAgreementActions from '../hooks/APIHooks/appointments/useRetainAgreementActions';
import { RetainAgreement } from '../types/retain';

// datatype of the context declared here
interface IRetainHistoryContext {
  selectedRetainHistory: RetainAgreement | null;
  retainHistoryList: Array<RetainAgreement>;
  showDetailsModal: boolean;
  setSelectedRetainHistory: React.Dispatch<
    React.SetStateAction<RetainAgreement | null>
  >;
  setShowDetailsModal: React.Dispatch<React.SetStateAction<boolean>>;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

// creating the context here
const RetainHistoryContext = createContext<IRetainHistoryContext | null>(null);

const RetainHistoryProvider = ({ children }: { children: React.ReactNode }) => {
  // integration of react hooks here
  const [selectedRetainHistory, setSelectedRetainHistory] =
    useState<RetainAgreement | null>(null);

  const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);

  // integration of custom API hooks here
  const { getRetainAgreementListHandler } = useRetainAgreementActions(
    'retainAgreementList'
  );

  console.log(
    'RETAIN AGREEMENT LIST: ',
    getRetainAgreementListHandler.data?.data
  );

  // rendering the context provider here
  return (
    <RetainHistoryContext.Provider
      value={{
        selectedRetainHistory,
        retainHistoryList: getRetainAgreementListHandler.data?.data || [],
        showDetailsModal,
        setSelectedRetainHistory,
        setShowDetailsModal,
        isError: getRetainAgreementListHandler.isError,
        isLoading: getRetainAgreementListHandler.isLoading,
        isSuccess: getRetainAgreementListHandler.isSuccess,
      }}
    >
      {children}
    </RetainHistoryContext.Provider>
  );
};

export default RetainHistoryProvider;

// custom hook to access the context declared here
export const useRetainHistoryContext = () => {
  const context = useContext(RetainHistoryContext);

  if (!context) {
    throw new Error(
      'useRetainHistoryContext must be within RetainHistoryProvider!'
    );
  }

  return context;
};
